// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__3vS5j"};